import React from 'react';
import i18next from 'i18next';

import './i18n';
import styles from './styles.module.scss';

const UNPUBLISHED = 'unpublished';

interface PublicationBadgeProps {
  status?: string;
  className?: string;
}

/** Renders a "No Publicado" badge only for unpublished projects; nothing otherwise. */
function PublicationBadge({ status, className }: PublicationBadgeProps) {
  if (status !== UNPUBLISHED) {
    return null;
  }

  return <span className={`${styles.badge} ${className || ''}`}>{i18next.t('common:unpublished')}</span>;
}

export default PublicationBadge;
